// define initialization procedures

page.init = function(){
    log.page("INIT");
    window.onbeforeunload = function () {
        window.scrollTo(0,0);
    };

    if(!page.three.init()){
        //console.error("Failed to initialize WebGL");
        log.webgl("FAILED: couldn't initialize WebGL", 1);
    }else{
        page.three.v.readyToShow = true;
        page.three.control.bg.fadeIn(1500);
        //console.log("WebGL ready");
        log.webgl("READY");
    }
    $(document).ready(function (e) {

        page.main.initOnce();
        page.main.init();
        page.v.loading.reset();
        
        page.ajaxLoaded();
       // page.serverEvents();

        page.update();

    });

    $(window).resize($.throttle(100, page.resize));
    $(window).scroll($.throttle(32, page.scroll));
    $(window).mousemove($.throttle(32, page.mouseMove));
    page.scroll();
    page.resize();
    page.frame();
};


page.check = function(){
    log.page("CHECK  | Checklist");
    $.each(page.checklist, function (k, v) {
        v.check();
    });

};

page.load = function(){
    log.page("LOAD");
    if(page.v.firstLoad){
        page.v.firstLoad = false;
    }

    page.control.preloader.hide();
    $.each(page.checklist, function(k, v){
        if(v.enabled) v.init();
    });
    //page.main.v.nextPage = name;
    //page.main.v.nextPageCallback = callback;
    //page.state.unload();
};

page.unload = function(){
    log.page("-====================================-",1);
    log.page("UNLOAD");
    $.each(page.checklist, function(k, v){
        if(v.enabled) v.unload();
    });
    page.control.particles.scrolling(false);
    page.v.loading.reset();
    page.control.preloader.show();
};

page.frame = function(){
    requestAnimationFrame(page.frame);
    var v = page.v;
    v.time.current = performance.now();
    v.scroll.calc();
    v.mouse.calc();

    if(!page.v.loading._done){
        page.v.loading.update();
    }else{
        $.each(page.checklist, function(k, o){
            if(o.enabled) o.calc();
        });
    }

    if(page.three.v.readyToShow){
        page.three.calc();
        if(page.three.v.alwaysRender) page.three.render();
    }
};

page.resize = function(){
    if(page.three.v.readyToShow){
        page.three.resize();
    }
    if(page.main.v.pageReady){
        page.main.resize();
    }
    if(page.v.loading._done){
        $.each(page.checklist, function(k, o){
            if(o.enabled) o.resize();
        });
    }
    page.v.scroll.update();
}

page.scroll = function(){
    page.v.scroll.update();
    if(page.main.v.pageReady){
        page.main.scroll();
        if(page.state.scroll){
            page.state.scroll();
        }
        if(page.v.loading._done){
            $.each(page.checklist, function(k, o){
                if(o.enabled) o.scroll();
            });
        }
    }
}

page.mouseMove = function(e){
    page.v.mouse.update(e);
}